export default __webpack_public_path__ + "static/home-screen-2-ffb6569318e34f2962bfbc8ec9cca017.webp";